module.exports = __webpack_public_path__ + "static/merch7Front-7de684a6cf64f90ae82c90bb722daa38.png";